
import axios from 'axios';
import React, { useEffect, useState } from 'react';
/* import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../Firebase/FirebaseConfig"; */

import ProfileLoading from './ProfileLoading';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Profile() {

    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [userData, setUserData] = useState(null);
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [agegroupData, setAgegroupData] = useState([]);
    const [genderData, setGenderData] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const userId = localStorage.getItem('userid');

    const [userStatistics, setStatisticData] = useState([]);
    /*  const [user, setUser] = useState(null); */

    const [formData, setFormData] = useState({
        name: '',
        genderid: 0,
        phonenumber: '',
        stateid: 0,
        districtid: 0,
        agegroupid: 0,
        school_name: '',
        zipcode: '',
        udise: '',
        userid: userId,
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const url = `${baseURL}/editprofile/`;
        const headers = {
            accept: 'application/json',
            Authorization: apiKey,
            'Content-Type': 'application/json'
        };

        try {
            const response = await axios.post(url, formData, { headers });
            /*  console.log('Response:', response.data); */

            toast.success('Profile updated successfully!');
            window.location.reload();
            setIsEditMode(false);
            setUserData(response.data);
        } catch (error) {
            console.error('Error:', error.response ? error.response.data : error.message);
            alert('Profile update unsuccessful!');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleValueChange = (e) => {
        const input = e.target.value;
        const sanitizedInput = input.replace(/\D/g, '').slice(0, 10);
        if (input.length > 10) {
            alert('Phone number cannot be more than 10 digits. Please enter a valid phone number.');
            return;
        }
        setFormData(prevFormData => ({ ...prevFormData, phonenumber: sanitizedInput }));

    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/basicdata/?userid=${userId}`, {
                    headers: {
                        accept: 'application/json',
                        Authorization: apiKey
                    }
                });

                /* console.log(response.data); */
                setStatisticData(response.data.user_statistics);
                setStateData(response.data.states_data);
                setDistrictData(response.data.districts_data);
                setAgegroupData(response.data.agegroup_data);
                setGenderData(response.data.genders_data);
                setUserData(response.data.usersdata[0]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL, apiKey]);

    const handleStateChange = (e) => {
        const { name, value } = e.target;

        if (name === 'stateid') {
            const selectedState = stateData.find(state => state._id === parseInt(value));
            const filteredDistricts = districtData.filter(district => district.stateid === selectedState._id);

            setFormData({
                ...formData,
                [name]: parseInt(value),
                districtid: filteredDistricts.length > 0 ? filteredDistricts[0]._id : 0,
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const formatDate = (isoDate) => {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return new Date(isoDate).toLocaleDateString('en-GB', options);
    };

    const getGenderById = (id) => {
        const gender = genderData.find(g => g._id === id);
        return gender ? gender.gender : '';
    };

    const getAgegroupById = (id) => {
        const ageGroup = agegroupData.find(group => group._id === id);
        return ageGroup ? ageGroup.agegroup : '';
    };

    const getStateNameById = (id) => {
        const state = stateData.find(state => state._id === id);
        return state ? state.statename : '';
    };

    const getDistrictNameById = (id) => {
        const district = districtData.find(district => district._id === id);
        return district ? district.districtname : '';
    };

    const stateName = userData ? getStateNameById(userData.stateid) : '';
    const districtname = userData ? getDistrictNameById(userData.districtid) : '';
    const gendername = userData ? getGenderById(userData.genderid) : '';
    const agegroupname = userData ? getAgegroupById(userData.agegroupid) : '';
    const joinedDate = userData ? formatDate(userData.createdon) : '';
    const userNameInitial = userData && userData.name ? userData.name.slice(0, 1) : '';



    const enableEditMode = () => {
        setFormData({
            name: userData.name,
            genderid: userData.genderid,
            phonenumber: userData.phonenumber,
            stateid: userData.stateid,
            districtid: userData.districtid,
            agegroupid: userData.agegroupid,
            school_name: userData.school_name,
            zipcode: userData.zipcode,
            udise: userData.udise,
            userid: userId,
        });
        setIsEditMode(true);
    };

    /*  useEffect(() => {
        
         const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
             setUser(currentUser);
         });
         return () => unsubscribe();
     }, []); */



    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                theme="dark"
            />

            {userData ? (
                <section className="profile-part my-profile my-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-xl-3">
                                <div className="account-card">
                                    <div className="profile-image text-center py-3">
                                        <a href="/profile"><span>{userNameInitial}</span></a>
                                    </div>

                                    <h4 className='text-center text-capitalize'>{userData.name} </h4>
                                    <h6 className='text-center text-wrap text-break'>{userData.email} </h6>
                                    <h6 className='text-center'>Joined on {joinedDate}</h6>
                                    <div className="section-btn-25">
                                        {!isEditMode && (
                                            <button className="btn-6 view-all-btnn text-capitalize" onClick={enableEditMode}>
                                                Update profile
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-xl-9">
                                <div className="account-card">
                                    <div className="account-title d-none">
                                        <h4>statistics</h4>
                                    </div>

                                    <div className="account-content pt-4 d-none">
                                        <div className="row our-profile">

                                            <div className="col-md-3">
                                                <div className="product-card">
                                                    <div className="row align-items-center">
                                                        <div className="col-8 col-sm-12 col-xl-8 my-auto">
                                                            <div className="d-flex d-sm-block d-md-flex align-items-center">
                                                                <h4 className="mb-0">{userStatistics.current_streak}</h4>
                                                            </div>
                                                            <h6 className="text-muted font-weight-normal">Current Streak</h6>
                                                        </div>
                                                        <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right our-icon">
                                                            <i className="fas fa-fire"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="product-card">
                                                    <div className="row align-items-center">
                                                        <div className="col-8 col-sm-12 col-xl-8 my-auto">
                                                            <div className="d-flex d-sm-block d-md-flex align-items-center">
                                                                <h4 className="mb-0">{userStatistics.longest_streak}</h4>
                                                            </div>
                                                            <h6 className="text-muted font-weight-normal">Longest Streak</h6>
                                                        </div>
                                                        <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right our-icon">
                                                            <i className="fas fa-star"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="product-card">
                                                    <div className="row align-items-center">
                                                        <div className="col-8 col-sm-12 col-xl-8 my-auto">
                                                            <div className="d-flex d-sm-block d-md-flex align-items-center">
                                                                <h4 className="mb-0">{userStatistics.visited_books}</h4>
                                                            </div>
                                                            <h6 className="text-muted font-weight-normal">Visited Books</h6>
                                                        </div>
                                                        <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right our-icon">
                                                            <i className="fas fa-book"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="product-card">
                                                    <div className="row align-items-center">
                                                        <div className="col-8 col-sm-12 col-xl-8 my-auto">
                                                            <div className="d-flex d-sm-block d-md-flex align-items-center">
                                                                <h4 className="mb-0">{userStatistics.reading_seconds}</h4>
                                                            </div>
                                                            <h6 className="text-muted font-weight-normal">Reading Hours</h6>
                                                        </div>
                                                        <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right our-icon">
                                                            <i className="far fa-clock"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="product-card">
                                                    <div className="row align-items-center">
                                                        <div className="col-8 col-sm-12 col-xl-8 my-auto">
                                                            <div className="d-flex d-sm-block d-md-flex align-items-center">
                                                                <h4 className="mb-0">{userStatistics.user_points}</h4>
                                                            </div>
                                                            <h6 className="text-muted font-weight-normal">Total Points</h6>
                                                        </div>
                                                        <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right our-icon">
                                                            <i className="fas fa-users"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="account-title">
                                        <h4>Your Profile</h4>
                                    </div>
                                    <div className="account-content">

                                        {isEditMode ? (
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="name"
                                                                name="name"
                                                                value={formData.name}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="gender">Gender</label>
                                                            <select
                                                                className="form-control"
                                                                id="gender"
                                                                name="genderid"
                                                                value={formData.genderid}
                                                                onChange={handleChange}
                                                                required
                                                            >

                                                                {genderData.map((gender) => (
                                                                    <option key={gender._id} value={gender._id}>
                                                                        {gender.gender}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="phonenumber">Phone Number</label>
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                id="phonenumber"
                                                                name="phonenumber"
                                                                value={formData.phonenumber}
                                                                onChange={handleValueChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="agegroup">Age Group</label>
                                                            <select
                                                                className="form-control"
                                                                id="agegroup"
                                                                name="agegroupid"
                                                                value={formData.agegroupid}
                                                                onChange={handleChange}
                                                                required
                                                            >

                                                                {agegroupData.map((agegroup) => (
                                                                    <option key={agegroup._id} value={agegroup._id}>
                                                                        {agegroup.agegroup}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="state">State</label>
                                                            <select
                                                                className="form-control"
                                                                id="state"
                                                                name="stateid"
                                                                value={formData.stateid}
                                                                onChange={handleStateChange}
                                                                required
                                                            >

                                                                {stateData.map((state) => (
                                                                    <option key={state._id} value={state._id}>
                                                                        {state.statename}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="district">District</label>
                                                            <select
                                                                className="form-control"
                                                                id="district"
                                                                name="districtid"
                                                                value={formData.districtid}
                                                                onChange={handleChange}
                                                                required
                                                            >

                                                                {districtData
                                                                    .filter((district) => district.stateid === formData.stateid)
                                                                    .map((district) => (
                                                                        <option key={district._id} value={district._id}>
                                                                            {district.districtname}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="zipcode">Zip Code</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="zipcode"
                                                                name="zipcode"
                                                                value={formData.zipcode}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="udise">UDISE</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="udise"
                                                                name="udise"
                                                                value={formData.udise}
                                                                onChange={handleChange}

                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-4">
                                                        <div className="form-group">
                                                            <label htmlFor="school">School Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="school"
                                                                name="school_name"
                                                                value={formData.school_name}
                                                                onChange={handleChange}

                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="section-btn-25">
                                                        <button type="submit" className="btn-6 view-all-btnn">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>

                                            </form>
                                        ) : (
                                            <div className="row">
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">name</label>
                                                        <input className="form-control" type="text" placeholder={userData.name} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">gender</label>
                                                        <input className="form-control" type="text" placeholder={gendername} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">Phone Number</label>
                                                        <input className="form-control" type="text" placeholder={userData.phonenumber} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">Age Group</label>
                                                        <input className="form-control" type="text" placeholder={agegroupname} readOnly />
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">State</label>
                                                        <input className="form-control" type="text" placeholder={stateName} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">District</label>
                                                        <input className="form-control" type="text" placeholder={districtname} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">Zip Code</label>
                                                        <input className="form-control" type="text" placeholder={userData.zipcode} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">School UDISE</label>
                                                        <input className="form-control" type="text" placeholder={userData.udise} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">School Name</label>
                                                        <input className="form-control" type="text" placeholder={userData.school_name} readOnly />
                                                    </div>
                                                </div>

                                            </div>
                                        )}


                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            ) : (
                <ProfileLoading />
            )}
        </>

    )
}
